import { Alert } from "@mui/material";
import RouterLink from "@poseidon/ui/components/RouterLink";
import React from "react";
import config from "@poseidon/utils/config";

export function ApplicationHasAgreementWarning({ application, sx }) {
  const hasAgreement = !!application?.agreement?.id;
  if (hasAgreement) {
    return (
      <Alert severity="warning" sx={sx}>
        Application has progressed to an agreement -{" "}
        <RouterLink to={`/agreements/${application.agreement.id}`}>
          View Agreement
        </RouterLink>
      </Alert>
    );
  }
  if (application.status === "rejected") {
    return (
      <Alert severity="warning" sx={sx}>
        Application has been denied credit
      </Alert>
    );
  }
  if (application.status === "closed") {
    const reason = application.closeReason
      ? config.getCloseReasonLabel(application.closeReason)
      : undefined;
    return (
      <Alert severity="error" sx={sx}>
        Application has been closed
        {reason ? ` — ${reason}` : ""}
        {application.closeReasonDetail
          ? ` (${application.closeReasonDetail})`
          : ""}
      </Alert>
    );
  }
  if (application.status === "expired") {
    return (
      <Alert severity="error" sx={sx}>
        Application has expired
      </Alert>
    );
  }
  return false;
}
